export default __webpack_public_path__ + "static/media/3091.181a6989.jpg";